import { BasicInfoSection } from './BasicInfoSection';
import { EventConfigSection } from './EventConfigSection';
import { FeesSection } from './FeesSection';
import { RegistrationInfoSection } from './RegistrationInfoSection';
import { WorkflowGatingSection } from './WorkflowGatingSection';

export function CompetitionForm({
  formData,
  setFormData,
  readOnly = false,
  venues,
  clubs,
  schedules,
  handleStartDateBlur
}) {
  return (
    <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-2">
      <BasicInfoSection
        formData={formData}
        setFormData={setFormData}
        clubs={clubs}
        venues={venues}
        readOnly={readOnly}
        handleStartDateBlur={handleStartDateBlur}
      />

      <EventConfigSection
        formData={formData}
        setFormData={setFormData}
        schedules={schedules}
        readOnly={readOnly}
      />

      <FeesSection
        formData={formData}
        setFormData={setFormData}
        readOnly={readOnly}
      />

      <RegistrationInfoSection
        formData={formData}
        setFormData={setFormData}
        readOnly={readOnly}
      />

      <WorkflowGatingSection
        data={formData}
        setData={setFormData}
        readOnly={readOnly}
      />
    </div>
  );
}
